exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-2540d5a0!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/ProductDynamics/Index.vue
// module id = 331
// module chunks = 0